import styled from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Container = styled('div')`
  padding-right: 54px;
  height: 100%;
`;

export const TitleContainer = styled('div')`
  display: flex;
  padding-bottom: ${theme.spacing.xLarge};
`;

export const Title = styled('div')`
  font-family: ${theme.font.family};
  font-weight: ${theme.font.weight.semiBold};
  font-size: 20px;
  color: ${colors.black};
`;

export const TagContainer = styled('div')`
  width: 47px;
  height: 24px;
  margin-left: ${theme.spacing.xSmall};
  background: ${theme.color.designSystem.background.light.warning};
  border-radius: ${theme.spacing.xxSmall};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BetaTag = styled('span')`
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.small};
  line-height: 16px;
  letter-spacing: 0.4px;
`;

export const Iframe = styled('iframe')`
  width: 100%;
  height: 100%;
`;
